import {Component, EventEmitter, Input, OnInit, Output, ViewChild, inject} from '@angular/core';
import {
  IGX_INPUT_GROUP_DIRECTIVES,
  IgxInputDirective,
  IgxInputGroupComponent, IgxInputGroupType, IgxPrefixDirective, IgxSuffixDirective
} from '@infragistics/igniteui-angular/input-group';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import {ClsUtil} from '../../../../util/cls-util';
import {EnumTresPuntos} from '../../../../core/models/enum/enum-tres-puntos';
import {CiudadesComponent} from '../../../02-catalogos/ciudades/ciudades.component';
import {ClsConfig} from '../../../../util/cls-config';
import {UnidadesComponent} from '../../../02-catalogos/unidades/unidades.component';
import {TiposDeInsumosComponent} from '../../../02-catalogos/tiposdeinsumos/tipos-de-insumos.component';
import {FamiliasComponent} from '../../../02-catalogos/familias/familias.component';
import {EstadosComponent} from '../../../02-catalogos/estados/estados.component';
import {TiposDeLicitacionesComponent} from '../../../02-catalogos/tiposdelicitaciones/tipos-de-licitaciones.component';
import {VendedoresComponent} from '../../../02-catalogos/vendedores/vendedores.component';
import {EmpresasComponent} from '../../../02-catalogos/empresas/empresas.component';
import {ClientesComponent} from '../../../02-catalogos/clientes/clientes.component';
import {ResponsablesComponent} from '../../../02-catalogos/responsables/responsables.component';
import {ProveedoresComponent} from '../../../02-catalogos/proveedores/proveedores.component';
import {ContactosClientesComponent} from '../../../02-catalogos/contactos-clientes/contactos-clientes.component';
import {
  ClsCalendario,
  ClsCiudades,
  ClsClientes,
  ClsContactoCliente,
  ClsEmpresas,
  ClsEstados,
  ClsFamilias,
  ClsProveedores,
  ClsRegion,
  ClsResponsables, ClsTipoAnticipos,
  ClsTipoInsumos, ClsTipoJornada,
  ClsTipoLicitaciones,
  ClsUnidades,
  ClsVendedores
} from '../../../../core/models/cls-catalogos';
import {ClsObjGenerico} from '../../../../clases-pu/util/cls-obj-generico';
import {RegionesComponent} from '../../../02-catalogos/regiones/regiones.component';
import {VtnGenericaComponent} from '../../ventanas/vtn-generica/vtn-generica.component';
import {CatalogoGeneralComponent} from '../catalogo-general/catalogo-general.component';
import {ClsCatalogosExpIns} from '../../../../core/models/cls-catalogo-general';
import {
  ClsObjExplosionDeInsumos
} from '../../../../clases-pu/01-presupuesto/menu-presupuesto/cls-obj-explosion-de-insumos';
import {EnumCatalogoGralBanderas} from '../../../../core/models/enum/enum-catalogo-gral-banderas';
import {TipoAnticipoComponent} from '../../../02-catalogos/tipo-anticipo/tipo-anticipo.component';
import {ProgramasDeObrasComponent} from '../../../02-catalogos/programas-de-obras/programas-de-obras.component';
import {TiposJornadasComponent} from '../../../02-catalogos/tipos-jornadas/tipos-jornadas.component';
import {
  AniosPorcentajeAplicacionComponent
} from '../../../02-catalogos/anios-porcentaje-aplicacion/anios-porcentaje-aplicacion.component';
import {TranslateModule} from '@ngx-translate/core';
import {EnumPosicionBtn} from "../../../../core/models/enum/enum-mas-opciones";
import {INeodataBtnsFooter} from "../../../../core/models/interfaces/generico-interface";
import {TipoMensajesService} from "../../../../core/services/tipo-mensajes.service";
import {CrearComponenteDinamicoService} from "../../../../core/services/crear-componente-dinamico.service";
import {CalendariosComponent} from "../../../02-catalogos/calendarios/calendarios.component";
import {GridPartidasComponent} from "../partida/grid-partidas/grid-partidas.component";
import {ClsArbolPartida} from "../../../../core/models/cls-partida";
import {ClsPrograma} from "../../../../core/models/cls-programa";
import { IGridCellEventArgs } from '@infragistics/igniteui-angular/grids/core';

@Component({
  selector: 'app-tres-puntos',
  templateUrl: './tres-puntos.component.html',
  styleUrls: ['./tres-puntos.component.scss'],
  imports: [
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxIconComponent,
    IgxButtonModule,
    IgxButtonDirective,
    TranslateModule,
    IgxTextSelectionDirective,
    IgxRippleDirective,
    IgxFocusDirective,
    IgxInputGroupComponent,
    IgxPrefixDirective,
    IgxSuffixDirective
  ]
})
export class TresPuntosComponent extends ClsConfig implements OnInit {
  private tipoMsg = inject(TipoMensajesService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('inputCatalogos', {read: IgxInputDirective, static: true})
  public inputCatalogos: IgxInputDirective;
  /**
   *   Unidades = 0
   *   TiposDeInsumo = 1
   *   Familias = 2
   *   Estados = 3 ...
   *   Ciudades,
   *   Proveedores,
   *   Responsables,
   *   Clientes,
   *   Empresas,
   *   Calendarios,
   *   Vendedores,
   *   TiposDeLicitaciones,
   *   Monedas,
   *   ContactoCliente,
   *   Region,
   *   CatalogoGeneral,
   *   TipoAnticipo,
   *   ProgramaDeObra,
   *   TipoDeJornadas,
   *   AnioPorcentajeAplicacion,
   *   Fechas,
   *   Partidas
   */
  @Input()
  public tipoCatalogo: EnumTresPuntos;
  @Input()
  public porcentaje: number;
  @Input()
  public estilo: string;
  @Input()
  public tipo: IgxInputGroupType = 'line';
  @Input()
  public tipoDato = 'string';
  /**
   * Valor que tiene el label de la etiqueta del componente.
   *
   * @remarks
   * Este campo define el texto que se mostrará como etiqueta (label) en el componente de entrada.
   * Si el valor es una cadena vacía, no se mostrará ninguna etiqueta.
   *
   * @example
   * // Asignar una etiqueta personalizada
   * etiqueta = 'Nombre del Cliente';
   *
   * @defaultValue ''
   */
  @Input()
  public etiqueta = '';
  @Input()
  public idPpto: bigint;
  @Input()
  public idDefault: any;
  @Input()
  public valorDefault: any = '';
  @Input()
  public filaSeleccionada: any;
  @Input()
  public prefixTitulo = '';
  /**
   * Solo se ocupa para el catalogo de partidas
   * False = muestra todo el arbol de partidas plano
   * True = muestra todas las partidas que contengan conceptos, osea de ultimo nivel
   */
  @Input()
  public mostrarUltimoNivel = false;
  /**
   * Solo se ocupa para el detalle del cliente
   */
  @Input()
  public dataClientes: ClsClientes;
  /**
   * Solo se ocupa para filtrar los tipos del catalogo general
   */
  @Input()
  public filtrarTipo: number[] = [];
  /**
   * Solo se ocupa para filtrar en base una bandera, ejemplo: CH, %
   * Ninguno = 0,
   * EsCH = 1,
   * EsPorcentaje = 2
   */
  @Input()
  public filtrarPorBandera: EnumCatalogoGralBanderas = EnumCatalogoGralBanderas.Ninguno;
  /**
   * Solo se ocupa para ver todas las columnas
   */
  @Input()
  public todasLasColumnas = false;
  @Input()
  public verLimpiar = true;
  @Input()
  public selectedRows: any[] = [];
  @Input()
  public hiddenBtn = false;
  @Input()
  public readOnlyInput = true;
  @Input()
  public desactivarInput = false;
  /**
   * Este campo se ocupa para la columna de codigo, solo se esta ocupando en CH
   * mas adelante puede que se ocupe en conceptos, matrices, etc
   * Por default esta en false que no se permita agregar codigo
   */
  @Input()
  public agregarCodigo = false;

  @Output()
  public eventFilaSeleccionada: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public eventComponente: EventEmitter<TresPuntosComponent> = new EventEmitter<TresPuntosComponent>();

  @Output()
  public eventCambioValor: EventEmitter<TresPuntosComponent> = new EventEmitter<TresPuntosComponent>();

  @Output()
  public eventAgregarCodigo: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  public eventLimpiarInput: EventEmitter<any> = new EventEmitter<any>();

  get mostrarEtiqueta(): boolean {
    return !!this.etiqueta;
  }

  get mostrarTituloPrefix(): boolean {
    return !!this.prefixTitulo;
  }

  public titulo: string;
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjExpInsumos: ClsObjExplosionDeInsumos = new ClsObjExplosionDeInsumos();

  constructor() {
    super();
  }


  ngOnInit(): void {
  }

  public limpiarInput(inputCatalogos: any) {
    inputCatalogos.value = '';
    this.valorDefault = '';
    this.idDefault = ClsUtil.bigintX(0);
    this.eventLimpiarInput.emit();
  }

  public cambioValor(valor: any) {
    if (this.tipoCatalogo === EnumTresPuntos.TiposDeInsumo) {
      if (Number(valor) <= 0 || ClsUtil.esNulo(valor)) {
        this.inputCatalogos.value = this.valorDefault;
        this.tipoMsg.mostrarMsg('MENSAJES.ALERT.TIPO_INSUMO_NO_VALIDO');
        return;
      }
    }
    this.valorDefault = valor;
    this.eventCambioValor.emit(this);
  }

  public customKeyDown(eventArgs: any, codigo: any) {
    const key = eventArgs.keyCode;
    // tab o enter
    if (key === 9 || key === 13) {
      this.mAgregarCodigo(codigo);
    }
  }

  public mAgregarCodigo(codigo: any) {
    try {
      if (this.agregarCodigo) {
        // validar si codigo es '' se limpia los datos
        if (ClsUtil.esNulo(codigo)) {
          this.eventAgregarCodigo.emit({registro: undefined, esNuevo: false, comp: this.inputCatalogos});
        }
        if (!ClsUtil.esNulo(codigo)) {
          // busca en el ppto activo, si no existe busca en el ppto maestro, si no existe, regresa undefined
          let expIns: ClsCatalogosExpIns = this.mObjExpInsumos.buscarCodigoEnExpIns(codigo);
          // si es Nulo, creamos obj con valores default, como si estuviera agregando el registro desde el catalogo general
          if (ClsUtil.esNulo(expIns)) {
            // mandar mensaje de que no existe en el catalogo y si desea agregarlo
            this.tipoMsg.mostrarQuestion(async (resp2: boolean) => {
              if (resp2) {
                expIns = this.mObjExpInsumos.inicializarAsignarRegistro(undefined);
                expIns.Codigo = codigo;
                this.eventAgregarCodigo.emit({registro: expIns, esNuevo: true, comp: this.inputCatalogos});
              } else {
                this.inputCatalogos.value = '';
                this.inputCatalogos.focus();
              }
            }, this.mObjGenerico.getTranslationsMensajes('MENSAJES.QUESTION.AGREGAR_REGISTRO_COD_NUEVO').replace('{0}', codigo));
          } else {
            this.eventAgregarCodigo.emit({registro: expIns, esNuevo: false, comp: this.inputCatalogos});
          }
        }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    }
  }

  public async onOpen() {
    const vtnGenerico: VtnGenericaComponent = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
    vtnGenerico.queVtnEstaAbierta = 'Catalogos';
    vtnGenerico.btnsAccion = [
      {
        id: 'ACEPTAR',
        texto: 'BOTONES.ACEPTAR',
        titulo: 'BOTONES.ACEPTAR',
        icono: '',
        tipoBoton: 'contained',
        posicion: EnumPosicionBtn.DERECHO
      },
      {
        id: 'CANCELAR',
        texto: 'BOTONES.CANCELAR',
        titulo: 'BOTONES.CANCELAR',
        icono: '',
        tipoBoton: 'flat',
        posicion: EnumPosicionBtn.DERECHO
      }
    ];
    try {
      switch (this.tipoCatalogo) {
        case EnumTresPuntos.Unidades:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.UNIDADES');
          const catUnidades: UnidadesComponent = vtnGenerico.crearComponente(UnidadesComponent);
          catUnidades.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catUnidades.cargarUnidades();
          if (catUnidades.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catUnidades.gridUnidad.hideRowSelectors = true;
          catUnidades.gridUnidad.selectRowOnClick = true;
          catUnidades.gridUnidad.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catUnidades.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catUnidades.gridUnidad.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsUnidades = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = valor.IdUnidad;
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Unidad;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.TiposDeInsumo:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.TIPOS_INSUMOS');
          const catTiposDeInsumo: TiposDeInsumosComponent = vtnGenerico.crearComponente(TiposDeInsumosComponent);
          catTiposDeInsumo.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catTiposDeInsumo.cargarTiposDeInsumos();
          if (catTiposDeInsumo.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catTiposDeInsumo.gridTiposInsumos.hideRowSelectors = true;
          catTiposDeInsumo.gridTiposInsumos.selectRowOnClick = true;
          catTiposDeInsumo.gridTiposInsumos.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catTiposDeInsumo.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catTiposDeInsumo.gridTiposInsumos.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsTipoInsumos = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = valor.IdTipoInsumo;
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.TipoInsumo;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Familias:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.FAMILIAS');
          const catFamilias: FamiliasComponent = vtnGenerico.crearComponente(FamiliasComponent);
          catFamilias.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catFamilias.cargarFamilias();
          if (catFamilias.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catFamilias.gridFamilias.hideRowSelectors = true;
          catFamilias.gridFamilias.selectRowOnClick = true;
          catFamilias.gridFamilias.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catFamilias.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catFamilias.gridFamilias.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsFamilias = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = ClsUtil.bigintX(valor.IdFamilia);
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Estados:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.ESTADOS');
          const catEstados: EstadosComponent = vtnGenerico.crearComponente(EstadosComponent);
          catEstados.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catEstados.cargarEstados();
          if (catEstados.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catEstados.gridEstados.hideRowSelectors = true;
          catEstados.gridEstados.selectRowOnClick = true;
          catEstados.gridEstados.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catEstados.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catEstados.gridEstados.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsEstados = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = ClsUtil.bigintX(valor.IdEstado);
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Estado;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Ciudades:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.CIUDADES');
          const catCiudad: CiudadesComponent = vtnGenerico.crearComponente(CiudadesComponent);
          catCiudad.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catCiudad.cargarCiudades();
          if (catCiudad.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catCiudad.gridCiudades.hideRowSelectors = true;
          catCiudad.gridCiudades.selectRowOnClick = true;
          catCiudad.gridCiudades.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catCiudad.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catCiudad.gridCiudades.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsCiudades = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = ClsUtil.bigintX(valor.IdCiudad);
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Ciudad;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Proveedores:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.PROVEEDORES');
          const catProveedores: ProveedoresComponent = vtnGenerico.crearComponente(ProveedoresComponent);
          catProveedores.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catProveedores.cargarProveedores();
          if (catProveedores.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catProveedores.gridProveedores.hideRowSelectors = true;
          catProveedores.gridProveedores.selectRowOnClick = true;
          catProveedores.gridProveedores.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catProveedores.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catProveedores.gridProveedores.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsProveedores = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = ClsUtil.bigintX(valor.IdProveedor);
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Responsables:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.RESPONSABLES');
          const catResponsables: ResponsablesComponent = vtnGenerico.crearComponente(ResponsablesComponent);
          catResponsables.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catResponsables.cargarResponsables();
          if (catResponsables.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catResponsables.gridResponsables.hideRowSelectors = true;
          catResponsables.gridResponsables.selectRowOnClick = true;
          catResponsables.gridResponsables.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catResponsables.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catResponsables.gridResponsables.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsResponsables = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = ClsUtil.bigintX(valor.IdResponsable);
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Responsable;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Clientes:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.CLIENTES');
          const catClientes: ClientesComponent = vtnGenerico.crearComponente(ClientesComponent);
          catClientes.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catClientes.cargarClientes();
          if (catClientes.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catClientes.gridClientes.hideRowSelectors = true;
          catClientes.gridClientes.selectRowOnClick = true;
          catClientes.gridClientes.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catClientes.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catClientes.gridClientes.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsClientes = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = ClsUtil.bigintX(valor.IdCliente);
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Cliente;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Empresas:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.EMPRESAS');
          const catEmpresas: EmpresasComponent = vtnGenerico.crearComponente(EmpresasComponent);
          catEmpresas.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catEmpresas.cargarEmpresas();
          if (catEmpresas.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catEmpresas.gridEmpresas.hideRowSelectors = true;
          catEmpresas.gridEmpresas.selectRowOnClick = true;
          catEmpresas.gridEmpresas.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catEmpresas.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catEmpresas.gridEmpresas.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsEmpresas = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = ClsUtil.bigintX(valor.IdEmpresa);
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Empresa;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Vendedores:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.VENDEDORES');
          const catVendedores: VendedoresComponent = vtnGenerico.crearComponente(VendedoresComponent);
          catVendedores.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catVendedores.cargarVendedores();
          if (catVendedores.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catVendedores.gridVendedores.hideRowSelectors = true;
          catVendedores.gridVendedores.selectRowOnClick = true;
          catVendedores.gridVendedores.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catVendedores.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catVendedores.gridVendedores.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsVendedores = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = ClsUtil.bigintX(valor.IdVendedor);
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Vendedor;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.TiposDeLicitaciones:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.TIPO_LICITACIONES');
          const catTiposDeLicitaciones: TiposDeLicitacionesComponent = vtnGenerico.crearComponente(TiposDeLicitacionesComponent);
          catTiposDeLicitaciones.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catTiposDeLicitaciones.cargarTiposDeLicitaciones();
          if (catTiposDeLicitaciones.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catTiposDeLicitaciones.gridTiposDeLicitaciones.hideRowSelectors = true;
          catTiposDeLicitaciones.gridTiposDeLicitaciones.selectRowOnClick = true;
          catTiposDeLicitaciones.gridTiposDeLicitaciones.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catTiposDeLicitaciones.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catTiposDeLicitaciones.gridTiposDeLicitaciones.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsTipoLicitaciones = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = ClsUtil.bigintX(valor.IdTipoLicitacion);
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.TipoLicitacion;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Monedas:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.MONEDAS');
          break;
        case EnumTresPuntos.ContactoCliente:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.CONTACTOCLIENTE');
          const catContactoCli: ContactosClientesComponent = vtnGenerico.crearComponente(ContactosClientesComponent);
          catContactoCli.activarBotones = true;
          catContactoCli.dataClientes = this.dataClientes;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catContactoCli.cargarContactoClientes();
          if (catContactoCli.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catContactoCli.gridContactoClientes.hideRowSelectors = true;
          catContactoCli.gridContactoClientes.selectRowOnClick = true;
          catContactoCli.gridContactoClientes.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catContactoCli.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catContactoCli.gridContactoClientes.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsContactoCliente = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = ClsUtil.bigintX(valor.IdClienteContacto);
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.NombreClienteContacto;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Region:
          this.titulo = this.mObjGenerico.getTranslationsTitulosCatalogos('MENSAJES.GRALS.REGIONES');
          const catRegiones: RegionesComponent = vtnGenerico.crearComponente(RegionesComponent);
          catRegiones.activarBotones = true;
          vtnGenerico.open(400, 700, this.titulo, 'list_alt');
          await catRegiones.cargarRegiones();
          if (catRegiones.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catRegiones.gridRegion.hideRowSelectors = true;
          catRegiones.gridRegion.selectRowOnClick = true;
          catRegiones.gridRegion.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catRegiones.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catRegiones.gridRegion.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsRegion = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = valor.IdRegion;
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Region;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.CatalogoGeneral:
          this.titulo = this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.EXP_INSUMO');
          const catalogoGeneral: CatalogoGeneralComponent = vtnGenerico.crearComponente(CatalogoGeneralComponent);
          catalogoGeneral.filtrarTipo = this.filtrarTipo;
          catalogoGeneral.todasLasColumnas = this.todasLasColumnas;
          catalogoGeneral.filtrarPorBandera = this.filtrarPorBandera;
          catalogoGeneral.cargarDatos();
          catalogoGeneral.gridExpInsumos.hideRowSelectors = true;
          catalogoGeneral.gridExpInsumos.selectRowOnClick = true;
          catalogoGeneral.gridExpInsumos.selectRows(this.selectedRows);
          vtnGenerico.open(455, 865, this.titulo, 'list_alt');
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catalogoGeneral.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catalogoGeneral.gridExpInsumos.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsCatalogosExpIns = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = valor.IdCatalogo;
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Codigo;
            this.filaSeleccionada = valor;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.TipoAnticipo:
          this.titulo = this.mObjGenerico.getTranslationsGetCatalogos('TITULOS.TIPO_ANTICIPO');
          const catTipoAnticipo: TipoAnticipoComponent = vtnGenerico.crearComponente(TipoAnticipoComponent);
          catTipoAnticipo.activarBotones = true;
          vtnGenerico.open(400, 400, this.titulo, 'request_quote');
          await catTipoAnticipo.cargarTipoAnticipo();
          if (catTipoAnticipo.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catTipoAnticipo.gridTipoAnticipo.hideRowSelectors = true;
          catTipoAnticipo.gridTipoAnticipo.selectRowOnClick = true;
          catTipoAnticipo.gridTipoAnticipo.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catTipoAnticipo.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catTipoAnticipo.gridTipoAnticipo.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsTipoAnticipos = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = valor.IdTipoAnticipo;
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.DescripcionTipoAnticipo;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.ProgramaDeObra:
          this.titulo = this.mObjGenerico.getTranslationsGetCatalogos('TITULOS.PROGRAMAS_DE_OBRA');
          const catProgramasDeObras: ProgramasDeObrasComponent = vtnGenerico.crearComponente(ProgramasDeObrasComponent);
          catProgramasDeObras.activarBotones = true;
          vtnGenerico.open(400, 1100, this.titulo, 'event_note');
          await catProgramasDeObras.cargarProgramas(this.idPpto);
          if (catProgramasDeObras.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catProgramasDeObras.gridProgramaObra.hideRowSelectors = true;
          catProgramasDeObras.gridProgramaObra.selectRowOnClick = true;
          catProgramasDeObras.gridProgramaObra.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catProgramasDeObras.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catProgramasDeObras.gridProgramaObra.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsPrograma = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = valor.IdPrograma;
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.NoPrograma;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.TipoDeJornadas:
          this.titulo = this.mObjGenerico.getTranslationsGetCatalogos('TITULOS.TIPO_JORNADAS');
          const catTipoJornada: TiposJornadasComponent = vtnGenerico.crearComponente(TiposJornadasComponent);
          catTipoJornada.activarBotones = true;
          vtnGenerico.open(400, 400, this.titulo, '');
          await catTipoJornada.cargarTiposDeJornadas();
          if (catTipoJornada.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catTipoJornada.gridTipoJornada.hideRowSelectors = true;
          catTipoJornada.gridTipoJornada.selectRowOnClick = true;
          catTipoJornada.gridTipoJornada.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catTipoJornada.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catTipoJornada.gridTipoJornada.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsTipoJornada = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = valor.IdTipoJornada;
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.TipoJornada;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.AnioPorcentajeAplicacion:
          this.titulo = this.mObjGenerico.getTranslationsGetCatalogos('TITULOS.ANIO_APLICACION');
          const catAnioPorcetApli: AniosPorcentajeAplicacionComponent = vtnGenerico.crearComponente(AniosPorcentajeAplicacionComponent);
          catAnioPorcetApli.activarBotones = true;
          vtnGenerico.open(400, 280, this.titulo, '');
          await catAnioPorcetApli.cargarAniosAplicacion();
          if (catAnioPorcetApli.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catAnioPorcetApli.gridAnioPorcAplicacion.hideRowSelectors = true;
          catAnioPorcetApli.gridAnioPorcAplicacion.selectRowOnClick = true;
          catAnioPorcetApli.gridAnioPorcAplicacion.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catAnioPorcetApli.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catAnioPorcetApli.gridAnioPorcAplicacion.doubleClick.subscribe((valorRow: any) => {
            const valor: any = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = valor.Clave;
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Clave;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Calendarios:
          this.titulo = this.mObjGenerico.getTranslationsGetCatalogos('TITULOS.CALENDARIO');
          const catCalendario: CalendariosComponent = vtnGenerico.crearComponente(CalendariosComponent);
          catCalendario.activarBotones = true;
          vtnGenerico.open(565, 1300, this.titulo, 'calendar_month');
          await catCalendario.cargarCalendarios();
          if (catCalendario.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          catCalendario.gridCalendario.hideRowSelectors = true;
          catCalendario.gridCalendario.selectRowOnClick = true;
          catCalendario.gridCalendario.selectRows([this.selectedRows]);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                catCalendario.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          catCalendario.gridCalendario.doubleClick.subscribe((valorRow: IGridCellEventArgs) => {
            const valor: ClsCalendario = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = valor.IdCalendario;
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.CodigoCalendario;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
        case EnumTresPuntos.Partidas:
          this.titulo = this.mObjGenerico.getTranslationsGetCatalogos('TITULOS.PARTIDAS');
          const gridPartidas: GridPartidasComponent = vtnGenerico.crearComponente(GridPartidasComponent);
          gridPartidas.mostrarUltimoNivel = this.mostrarUltimoNivel;
          gridPartidas.activarBotones = true;
          vtnGenerico.open(500, 750, this.titulo, '');
          gridPartidas.cargarPartidas();
          if (gridPartidas.errorAlCargar) {
            vtnGenerico.cerrarVentana();
          }
          gridPartidas.gridPartidas.hideRowSelectors = true;
          gridPartidas.gridPartidas.selectRowOnClick = true;
          gridPartidas.gridPartidas.selectRows(this.selectedRows);
          // EVENTO DE BOTONES VENTANA
          vtnGenerico.evtBoton.subscribe(async (btn: INeodataBtnsFooter) => {
            switch (btn.id) {
              case 'ACEPTAR':
                gridPartidas.registroSeleccionado();
                break;
              default: // cancelar
                vtnGenerico.close();
            }
          });
          gridPartidas.gridPartidas.doubleClick.subscribe((valorRow: any) => {
            const valor: ClsArbolPartida = !ClsUtil.esNulo(valorRow.cell) ? valorRow.cell.row.data : valorRow;
            this.eventFilaSeleccionada.emit(valor);
            this.idDefault = valor.IdPresupuestoPartida;
            this.selectedRows = [this.idDefault];
            this.valorDefault = valor.Partida;
            this.eventComponente.emit(this);
            vtnGenerico.close();
          });
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    }
  }

  public mostrarBotonLimpiar(valor: string): boolean {
    return this.verLimpiar && (valor?.trim() !== '' || valor === '0');
  }
}
